import React, { useState } from 'react'
import { Switch } from '~/lib/ui/switch'
import { apiPost } from '~/util/api'
import useTranslation from '../../shared/TranslationProvider'

export default function EmailPreferences({
  emailPreferences,
  coachWebinarEligible,
}) {
  const { t } = useTranslation('MyAccountSettings')

  const emailOptions = [
    {
      key: 'product_info',
      label: t('email_options.product_info_emails'),
      description: t('email_options.product_info_description'),
    },
    {
      key: 'survey_emails',
      label: t('email_options.survey_emails'),
      description: t('email_options.survey_description'),
    },
    {
      key: 'account_info',
      label: t('email_options.account_info_emails'),
      description: t('email_options.account_info_description'),
    },
    ...(coachWebinarEligible
      ? [
          {
            key: 'coach_live_events',
            label: t('email_options.live_events_emails'),
            description: t('email_options.live_events_description'),
          },
        ]
      : []),
  ]

  const [preferences, setPreferences] = useState({
    product_info: emailPreferences.productInfo,
    survey_emails: emailPreferences.survey,
    account_info: emailPreferences.accountInfo,
    coach_live_events: emailPreferences.coachLiveEvents,
  })

  const handleChange = (key) => async (checked) => {
    const newValue = !checked
    setPreferences((prev) => ({
      ...prev,
      [key]: newValue,
    }))

    try {
      await apiPost('/toggle_email_preferences', { key, unsubscribe: newValue })
    } catch (err) {
      console.error('Failed to update email preference:', err)
    }
  }

  return (
    <div
      className="h-fit rounded-[20px] border border-[#B9B9B9] p-4 sm:p-8"
      style={{ boxShadow: '0px 4px 4px 0px #99999930' }}
    >
      <h2 className="!text-xl font-normal">{t('email_preferences')}</h2>
      <div className="my-6 space-y-6">
        {emailOptions.map((option) => (
          <div key={option.key} className="flex items-center justify-between">
            <div>
              <div className="mb-2 font-bold">{option.label}</div>
              <div>{option.description}</div>
            </div>
            <Switch
              checked={!preferences[option.key]}
              onCheckedChange={handleChange(option.key)}
              className="ml-4"
            />
          </div>
        ))}
      </div>
      <p>{t('please_note')}</p>
    </div>
  )
}
